import {CanActivateFn} from '@angular/router';
import {inject} from '@angular/core';
import {GuardService} from '../guard/guard.service';
import {UserAclService} from '../../services/infrastructure/auth/acl/user-acl/user-acl.service';

export const crmGuard: CanActivateFn = () => {
  const guardService = inject(GuardService);
  const userAclService = inject(UserAclService);

  const hasPermissions = userAclService.isBrokerRole() || userAclService.isApplicationAdmin();
  if (hasPermissions) {
    return true;
  }
  return guardService.createRedirectUrlTree();
};
